"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = require("./Pagination");

Object.keys(_Pagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Pagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Pagination[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/pagination/index.js
// module id = 759
// module chunks = 0 15 16 17 18